module.exports = __webpack_public_path__ + "media/images/portal/i-5-cd207c0cc9cc578565c7dd539ecacad5.png";